import { render, staticRenderFns } from "./Newsannouncement.vue?vue&type=template&id=3de6125c&scoped=true"
import script from "./Newsannouncement.vue?vue&type=script&lang=js"
export * from "./Newsannouncement.vue?vue&type=script&lang=js"
import style0 from "./Newsannouncement.vue?vue&type=style&index=0&id=3de6125c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de6125c",
  null
  
)

export default component.exports